import { render, staticRenderFns } from "./ModifyTaskNum.vue?vue&type=template&id=40b2e14c&scoped=true"
import script from "./ModifyTaskNum.vue?vue&type=script&lang=js"
export * from "./ModifyTaskNum.vue?vue&type=script&lang=js"
import style0 from "./ModifyTaskNum.vue?vue&type=style&index=0&id=40b2e14c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b2e14c",
  null
  
)

export default component.exports